import { I18n } from 'react-redux-i18n';

const STAGE_KEYS = {
    iniciating: 'rocheTransaction.paymentFlow.progress.iniciating',
    signing: 'rocheTransaction.paymentFlow.progress.signing',
    broadcasting: 'rocheTransaction.paymentFlow.progress.broadcasting',
};

export const getBatchPaymentProgressLabel = (stage) => {
    const key = STAGE_KEYS[stage];
    return key ? I18n.t(key) : I18n.t('common.loading');
};

export const shouldShowBatchPaymentRecoveryAction = ({ loadingPayment, stage }) =>
    loadingPayment || stage === 'release_failed';
